import { getKeyForValueFromMap } from "../get-key-for-value-from-map/get-key-for-value-from-map";
import { driveTypeValueMappings } from "@cinch-nx/data-search";
export function convertFilterValueToUrlSegment(filterKey, filterValue) {
    const normalisedValue = filterValue.toLowerCase().replace(/ /g, "-");
    switch(filterKey){
        case "bodyType":
            return `${normalisedValue}-body-type`;
        case "colour":
            return `${normalisedValue}-colour`;
        case "doors":
            return `${normalisedValue}-doors`;
        case "driveType":
            return `${getKeyForValueFromMap(driveTypeValueMappings, filterValue)}-drive-type`;
        case "fuelType":
            return `${normalisedValue}-fuel-type`;
        case "gearbox":
            return `${normalisedValue}-gearbox`;
        case "seats":
            return `${normalisedValue}-seats`;
        default:
            return normalisedValue;
    }
}
